export default __webpack_public_path__ + "static/media/back_bg.0d7becd0.png";